<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Update Sample Type'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-hashtag"></p-inputicon>
                <input
                        pInputText
                        id="sample-type-name"
                        [(ngModel)]="this.sampleType.name"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Sample Type Name"
                />
            </p-iconfield>
            <label for="sample-type-name">Sample Type Name <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-iftalabel>
            <textarea pTextarea id="depIntroText" [(ngModel)]="this.sampleType.depIntroText" rows="5"
                      class="w-full"></textarea>
            <label for="depIntroText">DEP Intro Text</label>
            <p class="text-sm text-gray-500">This text will be displayed on the DEP page for the sample. Please use the
                &#123;TITLE&#125; to decide where in the text the product title should be shown.</p>
            <p class="text-sm text-gray-500">Example: "Explore the possibilities with the &#123;TITLE&#125;. This sample
                allows..."</p>
        </p-iftalabel>

        <p-ifta-label>
            <p-inputnumber [(ngModel)]="this.sampleType.defaultWeight" suffix="g"
                           class="w-full"
                           inputId="default-weight"></p-inputnumber>
            <label for="default-weight">Default weight</label>
        </p-ifta-label>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Update"
                icon="pi pi-check"
                (click)="updateSampleType()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>